<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          ref="settlementForm"
          :model="settlement"
          class="box"
          label-width="100px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.title')">{{
                  settlement.title
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.amount')">{{
                  settlement.amount | currency
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.totalQuantity')">{{
                  settlement.deliveryQuantity
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('delivery.express')">{{
                  settlement.clientName
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('settlement.settlerNameDelivery')">{{
                  settlement.settlerName
                }}</el-form-item>
              </el-col>
              <el-col v-if="settlement.settleAt !== null" :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  settlement.settleAt
                }}</el-form-item>
              </el-col>
              <el-col v-if="settlement.payoffAt !== null" :span="8">
                <el-form-item :label="$t('settlement.payoffAtDelivery')">{{
                  settlement.payoffAt
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb10">
            <legend>
              {{ $t("text.detail") }}
              <el-button type="default" size="mini" @click="download">
                {{ $t("action.download") }}
              </el-button>
            </legend>
            <vxe-table
              :data="settlement.deliveries"
              ref="itemsTable"
              class="recordsTable"
              size="mini"
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.serialNo }}
                  <div v-if="row.settle == true" class="green font10">
                    {{ $t("delivery.settle") }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="deliverMethodName"
                :title="$t('delivery.channel')"
                min-width="90"
              >
                <template v-slot="{ row }">
                  {{ row.deliverMethodName }}
                  <div class="font10">
                    {{ $t("delivery.tracking") }}:{{ row.tracking }}
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="weight"
                :title="$t('delivery.weight')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.weight }}
                  <div class="font10">
                    {{ $t("delivery.courierWeight") }}:{{ row.courierWeight }}
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="customerName"
                :title="$t('menu.customers')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <el-popover placement="right" width="260" trigger="click">
                    <div>
                      <div class="lineH24">
                        {{ $t("menu.customers") }}：{{ row.customerName }}
                      </div>
                      <div class="lineH24">
                        {{ $t("courier.phone") }}：{{ row.customerPhone }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.country") }}：
                        <span v-if="row.customerCountry != null">{{
                          $t("countries." + row.customerCountry)
                        }}</span>
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.province") }}：{{ row.customerProvince }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.city") }}：{{ row.customerCity }}
                      </div>
                      <div class="lineH24">
                        {{ $t("tenant.address") }}：{{ row.customerAddress }}
                      </div>
                      <div class="lineH24">
                        {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                      </div>
                    </div>
                    <div slot="reference" class="popover-reference">
                      {{ row.customerName }}
                    </div>
                  </el-popover>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="courierCost"
                :title="$t('delivery.deliverCost')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.courierCost | currency }}
                  <div class="font10">
                    {{ $t("order.extraChargeSimple") }}:{{
                      row.extraCharge | currency
                    }}
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="explain"
                :title="$t('settlement.explain')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.explain" :number="8" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="deliverAt"
                :title="$t('delivery.deliverAt')"
                min-width="100"
              />
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.remark" :number="8" />
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="90"
              >
                <template v-slot="{ row }">
                  <span v-if="settlement.payoffAt == null">
                    <el-button type="text" size="mini" @click="editItem(row)">{{
                      $t("text.edit")
                    }}</el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteItem(row)"
                      >{{ $t("text.remove") }}</el-button
                    >
                  </span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>

      <!-- 编辑Item -->
      <el-dialog
        :append-to-body="true"
        :title="$t('text.edit')"
        :visible.sync="editItemDF"
        :close-on-click-modal="false"
        width="30%"
      >
        <el-form ref="editItemForm" :model="editItemObj" label-width="80px">
          <el-form-item
            :prop="'courierCost'"
            :label="$t('delivery.deliverCost')"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('delivery.deliverCost')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input size="small" v-model.trim="editItemObj.courierCost" />
          </el-form-item>

          <el-form-item :prop="'explain'" :label="$t('settlement.explain')">
            <el-input
              size="small"
              v-model.trim="editItemObj.explain"
              type="textarea"
              :rows="2"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            :loading="editItemDoing"
            size="small"
            @click="editItemSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="editItemDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import DeliverySettlement from "@/api/deliverySettlement.js";
import Delivery from "@/api/delivery.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      settlement: {},
      payments: [],
      items: [],

      // 编辑Item
      editItemDF: false,
      editItemObj: {
        courierCost: null,
        explain: null,
      },
      row: null,
      editItemDoing: false,
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.loadingStart();
    DeliverySettlement.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.settlement = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    download() {
      const self = this;
      DeliverySettlement.exportExcelDetail(self.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 移除
    deleteItem(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRemove"))) {
        Delivery.removeDeliverySettlementById(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getSettlement();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑账单明细
    editItem(row) {
      const self = this;
      self.row = row;
      self.editItemObj.courierCost = row.courierCost;
      self.editItemObj.explain = row.explain;
      self.editItemDoing = false;
      self.editItemDF = true;
    },

    editItemSubmit() {
      const self = this;
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          self.editItemDoing = true;
          Delivery.updateCourierCost(self.row.id, self.editItemObj).then(
            function (res) {
              self.editItemDoing = false;
              self.editItemDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getSettlement();
            }
          );
        } else {
          return false;
        }
      });
    },

    getSettlement() {
      const self = this;
      DeliverySettlement.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.settlement = res.data.entity;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>